import { Size } from '@optimus-web/common';
import { useId } from '@optimus-web/helpers';
import { extractAriaProps } from '../utils/extractAriaProps';
import { Radio } from './Radio';
import { RadioButtonElement, RadioLabelElement } from './style';

export interface RadioElementProps {
    label?: React.ReactNode | string;
    checked?: boolean;
    value?: string;
    name?: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    inputHidden?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    size?: Exclude<Size, 'extraLarge'>;
    id?: string;
}

export const RadioButton: React.FC<RadioElementProps> = ({
    label,
    checked,
    value,
    name,
    required,
    className,
    disabled,
    inputHidden,
    onChange,
    onFocus,
    onBlur,
    size = 'medium',
    id: idProp,
    ...other
}: RadioElementProps) => {
    const [ariaProps, otherProps] = extractAriaProps(other);

    const generatedId = useId('radio-button');
    const id = idProp || generatedId;

    return (
        <RadioButtonElement checked={checked} disabled={disabled} {...otherProps}>
            <Radio
                id={id}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                inputHidden={inputHidden}
                name={name}
                required={required}
                value={value}
                size={size}
                {...ariaProps}
            />
            {label && (
                <RadioLabelElement disabled={disabled} htmlFor={id} checked={checked} size={size}>
                    {label}
                </RadioLabelElement>
            )}
        </RadioButtonElement>
    );
};
